<template>
  <div>
    <div class="header">
      <div class="title">{{ $t('settings.tab.sites') }}</div>
      <input
        v-hkldinput
        type="checkbox"
        @click="selectAll()"
        :disabled="!formOptions.hasSettingUpdateAccess || formOptions.readonly"
        :checked="all"
      >
      <span>{{ $t('action.selectAll') }}</span>
    </div>
    <div class="sites">
      <div
        v-for="site, index of sites"
        :key="index"
        class="site"
        :class="{light: keepTickSiteIds.includes(site.id) && !formOptions.readonly}"
      >
        <input
          type="checkbox"
          :value="site.id"
          v-hkldinput
          v-model="selected"
          :disabled="!formOptions.hasSettingUpdateAccess || formOptions.readonly || !clickableSiteIds.includes(site.id) || keepTickSiteIds.includes(site.id)"
        >
        <span>{{ site.code }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import lodash from 'lodash'
import { getLocations } from '@/api/locations/request'
import { getSelectedSites, getSitesByDepartmentId } from '@/api/departments/request'

const getIds = (list) => list.map((item) => item.id)

export default {
  name: 'Sites',
  model: {
    prop: 'extData',
    event: 'onChange',
  },
  props: ['extData', 'formOptions'],
  data () {
    return {
      deptId: undefined,
      preSites: [],
      selected: [],
      sites: [],
      selectedSiteIds: [],
      clickableSiteIds: [],
      keepTickSiteIds: [],
    }
  },
  computed: {
    all () {
      return this.selected.length === this.sites.length
    },
  },
  methods: {
    selectAll () {
      const curSelected = this.selected
        .filter((id) => this.clickableSiteIds.includes(id))
      if (curSelected.length !== this.clickableSiteIds.length) {
        this.selected = this.clickableSiteIds
      } else {
        this.selected = [...this.keepTickSiteIds]
      }
      this.selected = [...this.selectedSiteIds, ...this.selected]
    },
    updateSites: lodash.debounce(async function () {
      const deptId = this.extData.id
      if (!deptId) return
      const sites = await getSitesByDepartmentId(deptId)
      const selectedSiteIds = await getSelectedSites()
      const selected = getIds(selectedSiteIds)
      const [siteIds, selectedIds, dSiteIds] =
        [this.sites, selectedSiteIds, sites].map((list) => getIds(list))

      this.keepTickSiteIds = getIds(sites.filter(site => site.hasRecords))
      this.preSites = selected
      this.selected = this.formOptions.readonly ? dSiteIds : selected
      this.clickableSiteIds = siteIds.filter((id) => !selectedIds.filter((id) => !dSiteIds.includes(id)).includes(id))
      this.selectedSiteIds = this.sites
        .map((site) => site.id)
        .filter((id) => !this.clickableSiteIds.includes(id))
    }, 250),
  },
  watch: {
    async extData (val) {
      if (this.deptId !== val.id) return
      this.deptId = val.id
      this.updateSites()
    },
    async formOptions (val, pre) {
      if (val.readonly !== pre.readonly) {
        this.selected = this.preSites
        this.updateSites()
      }
    },
    selected (val) {
      const sites = val
        .filter((id) => this.clickableSiteIds.includes(id))
      this.extData.sites = sites
    },
    async '$route.params.id' () {
      this.sites = await getLocations()
      this.updateSites()
    },
  },
  async mounted () {
    this.sites = await getLocations()
    this.updateSites()
  },
}
</script>
<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .title {
    font-weight: bold;
  }
  input[type="checkbox"] {
    margin-left: 20px;
  }
  span {
    margin-left: 10px;
  }
}
.sites {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .site {
    display: flex;
    align-items: center;
    flex-basis: 16.667%;
    line-height: 40px;
    span {
      margin-left: 10px;
    }
  }
  .light input[type="checkbox"][disabled] {
    opacity: 1;
  }

}
</style>
